module.exports = __webpack_public_path__ + "static/img/xyjdck_main_header.5bfe633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xyjdck_main_header.png
// module id = i0qq
// module chunks = 167